import { createContext } from 'react';
import Config from '../types/Config';
import config from '../config';

// Use the centralized config which has runtime detection
export const defaultConfig = {
  apiUrl: config.apiURL,
};

const ConfigContext = createContext<Config>(defaultConfig);

export default ConfigContext;
